<template>
  <div class="indicator-container data-form-xs">
    <v-layout row class="f-s-10">
      <v-flex lg2>
        <span class="indicator-vertical">INDICATORS</span>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              color="primary"
              v-on="on"
              slot="activator"
              style="top: -30%"
              @click="openDialog">
              <v-icon>tune</v-icon>
            </v-btn>
          </template>
          <span>Indicators Setting</span>
        </v-tooltip>
      </v-flex>
      <v-flex lg10 style="margin-left: -4%">
        <div class="data-form-xs" style="line-height: 1;">
          <v-layout row wrap>
            <template v-for="(item, index) in indicator">
              <v-flex class="text-field" :class="getTextFieldClassByIndex(index)" :key="tool.getRandomKey (index)"><strong>{{ item.text }}</strong></v-flex>
              <v-flex :class="getClassByIndex(index)" v-if="item.hasLatestIn" :key="tool.getRandomKey (index)">
                Found {{ item.count || 0 }}
                <span v-if="item.count > 0">Latest In {{ item.latestIn }}</span>
              </v-flex>
              <v-flex :class="getClassByIndex(index)" v-else-if="item.key === dataType.IndicatorEnum.HIGH_RISK.key" :key="tool.getRandomKey (index)">{{ item.notes }}</v-flex>
              <v-flex lg2 v-else :key="tool.getRandomKey (index)">
                Found {{ item.count || 0 }}
              </v-flex>
            </template>
          </v-layout>
        </div>
      </v-flex>
      <v-dialog v-model="indicatorDialog" max-width="55%">
        <indicators-setting-dialog
          :loan="loan"
          :indicatorArray="indicator"
          :display="indicatorDialog"
          @hideDialog="hideIndicatorsSettingHandler"
          @indicatorDataUpdate="indicatorDataUpdateHandler"
        ></indicators-setting-dialog>
      </v-dialog>
    </v-layout>
  </div>
</template>

<script>
import { OriginationApi } from '@/api/pandaria'
import { DataType, Tool, Popup } from '@/util/index'
import { LIST_INIT_STRUCTURE } from '@/setting/list-header/list-init-structure'
import IndicatorsSettingDialog from '@/components/panda/common/dialog/IndicatorsSettingDialog'

const tool = new Tool()
const popup = new Popup()
export default {
  name: 'indicator-panel',
  components: {
    IndicatorsSettingDialog
  },
  props: {
    loan: Object
  },
  data () {
    return {
      indicator: LIST_INIT_STRUCTURE.INDICATOR,
      indicatorDialog: false,
      isLoaded: false,
      dataType: DataType,
      tool: tool
    }
  },
  computed: {
    loanId () {
      return this.loan.id
    }
  },
  mounted () {
    this.getIndicatorData(this.loanId)
  },
  methods: {
    getClassByIndex (index) {
      if (index % 2 === 0) {
        return 'lg6'
      } else {
        return 'lg5'
      }
    },
    getTextFieldClassByIndex (index) {
      if (index % 2 === 0) {
        return 'lg2'
      } else {
        return 'lg3'
      }
    },
    hideIndicatorsSettingHandler () {
      this.indicatorDialog = false
    },
    openDialog () {
      if (this.isLoaded) {
        this.indicatorDialog = true
      } else {
        popup.popupForWarning('Please wait a minute')
      }
    },
    indicatorDataUpdateHandler (indicatorData) {
      this.initIndicator(indicatorData)
    },
    getIndicatorData (loanId) {
      const $this = this
      $this.isLoaded = false
      OriginationApi.getIndicatorByLoanId(loanId, function (result) {
        if (tool.isEmpty(result) || result.length === 0) {
          OriginationApi.initiateLoanIndicator(loanId, function (result) {
            $this.initIndicator(result)
          })
        } else {
          $this.initIndicator(result)
        }
        $this.isLoaded = true
      })
    },
    initIndicator (result) {
      this.indicator = LIST_INIT_STRUCTURE.INDICATOR
      if (tool.isNotEmpty(result)) {
        for (let j = 0; j < this.indicator.length; j++) {
          const _indicatorItem = this.indicator[j]
          let hasIndicatorItemData = false
          for (let i = 0; i < result.length; i++) {
            const _resultItem = result[i]
            if (_indicatorItem.indicatorCode === _resultItem.indicatorCode) {
              hasIndicatorItemData = true
              this.setIndicatorData(_indicatorItem, _resultItem)
            }
          }
          if (!hasIndicatorItemData) {
            this.setIndicatorData(_indicatorItem)
          }
        }
      }
      this.$forceUpdate()
    },
    setIndicatorData (_indicatorItem, _resultItem) {
      const loanId = this.loan.id
      _indicatorItem.loanId = loanId
      if (_indicatorItem.key === DataType.IndicatorEnum.HIGH_RISK.key) {
        _indicatorItem.firstCheckbox = tool.isNotEmpty(_resultItem) && tool.isNotEmpty(_resultItem.notes)
        _indicatorItem.notes = tool.isEmpty(_resultItem) ? '' : _resultItem.notes
      } else {
        _indicatorItem.firstCheckbox = tool.isNotEmpty(_resultItem) && tool.isNotEmpty(_resultItem.count) && _resultItem.count !== 0
        _indicatorItem.secondCheckbox = tool.isNotEmpty(_resultItem) && tool.isNotEmpty(_resultItem.latestIn) && _resultItem.latestIn !== 0
        _indicatorItem.count = tool.isEmpty(_resultItem) ? '' : (_resultItem.count === 0 ? '' : _resultItem.count)
        _indicatorItem.latestIn = tool.isEmpty(_resultItem) ? '' : (_resultItem.latestIn === 0 ? '' : _resultItem.latestIn)
      }
    }
  }
}
</script>

<style lang="css">
  .indicator-container {
    font-size: 11px;
    line-height: 14px !important;
    width: 100%;
    height: 58px;
  }

  .indicator-container .layout .flex {
    padding: 0 !important;
    line-height: 14px;
  }

  .indicator-container .v-input {
    margin-top: unset;
    padding-top: unset;
    font-size: 12px !important;
  }

  .indicator-container .v-label {
    font-size: 12px !important;
  }

  .indicator-container .v-text-field input {
    font-size: 12px !important;
    padding: 0;
    line-height: 1;
  }

  .indicator-container .v-input--selection-controls__input {
    height: 14px;
    margin-right: 4px;
    margin-top: 0;
    width: 14px;
  }

  .indicator-container .v-icon {
    font-size: 14px;
  }

  .indicator-container .v-input--selection-controls__ripple {
    height: 14px;
    width: 14px;
    left: 0px;
    top: calc(50% - 7px);
  }

  .text-field {
    white-space: nowrap;
  }
  .indicator-vertical {
    writing-mode: vertical-rl;
    transform: rotate(180deg);
  }
</style>
